import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-setting',
  templateUrl: './support-setting.component.html',
  styleUrls: ['./support-setting.component.scss']
})
export class SupportSettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
